import type { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import type { IFup } from "@bbj-types/socialApply/fup";
import type { ObjectId } from "@bbj-types/utils/index";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import { axios, axiosApplyInstance } from "./axios";

export interface IGetSocialApplyResponse {
  _id: ObjectId;
  candidate: string;
  socialOffer: {
    _id: string;
    externalId: string;
    name: string;
    source: string;
    loc: [number, number];
    provider?: {
      name?: string;
      website?: string;
    };
    financingModes?: string[];
  };
  status: SocialApplyStatus;
  transitions: {
    date: Date;
    value: SocialApplyStatus;
    owner: string;
    _id: string;
    createdAt: Date;
    updatedAt: Date;
  }[];
  fup?: IFup;
}

export const useGetSocialApply = () => {
  const [state, execute, cancel] = axios<IGetSocialApplyResponse, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: ObjectId) => {
      return execute({
        url: `/applys/social/${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetSocialApplySuspense = (id: ObjectId) => {
  return useSuspense(
    () =>
      axiosApplyInstance.get<IGetSocialApplyResponse>(`/applys/social/${id}`, {
        withCredentials: true,
      }),
    [id]
  );
};
